import { EventBookableItem, EventTypeToVenueProfileTab } from '../../../../PublicUserProfile.types'

const getEventBookableItemLink = (event: EventBookableItem) => {
  return `/e${EventTypeToVenueProfileTab[event.eventType]}${event.shortId}`
}

export default getEventBookableItemLink
